import { RiqLinearPlayerElement, registerRiqLinearPlayer } from "./riq-linear-player.js";

export { embedCopy } from "./embed-copy.js";
export type {
  EmbedDisplay,
  LinearPlaybackSnapshot,
  LinearSource,
} from "./linear-controller.js";
export { LinearPlaybackController } from "./linear-controller.js";
export { RiqLinearPlayerElement, registerRiqLinearPlayer };

registerRiqLinearPlayer();

declare global {
  interface Window {
    RiqEmbed?: {
      register: typeof registerRiqLinearPlayer;
      RiqLinearPlayerElement: typeof RiqLinearPlayerElement;
    };
  }
}

if (typeof window !== "undefined") {
  window.RiqEmbed = {
    register: registerRiqLinearPlayer,
    RiqLinearPlayerElement,
  };
}
